// extracted by mini-css-extract-plugin
module.exports = {"page":"SettingsPage_page__3ujMB","tabs":"SettingsPage_tabs__2yeq8","buttons":"SettingsPage_buttons__2BIcJ","content":"SettingsPage_content__3P3nz"};